import React from "react";

const Badge = (props) => {
  const { price = "", variant = "gold" } = props;
  let badgeClasses = "";
  let textClasses = "";

  switch (variant) {
    case "gold":
      badgeClasses = "bg-[#AB7C3B] border-white";
      textClasses = "text-white";
      break;
    case "blue":
      badgeClasses = "bg-[#EFF6FF] border-white";
      textClasses = "text-[#233751]";
      break;
  
    default:
      badgeClasses = "bg-[#AB7C3B] border-white";
      textClasses = "text-white";
      break;
  }

  return (
    <div className="flex justify-center mt-4 pb-4">
      <div
        className={`inline-block ${badgeClasses} border rounded-full px-6 py-1 shadow-md`}
      >
        <p className={`italic text-[20px] ${textClasses}`}>
          Retail:{" "}
          <span className="relative inline-block">
            <span className={`text-[20px] ${textClasses}`}>{price}</span>
            <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <span className="block w-[90%] h-[2px] bg-[#690C0C] rotate-[8deg]"></span>
            </span>
          </span>{" "}
          -{" "}
          <span className={`font-bold text-[20px] ${textClasses}`}>
            FREE Today
          </span>
        </p>
      </div>
    </div>
  );
};

export default Badge;
